import React, { Fragment } from "react";
import * as s from "../StatsStyled";
import { LegendType } from "api/interfaces/chartInterface.interface";
import ToggleComponent from "components/atoms/toggle/Toggle";
import { useStatsWidget } from "./GridChartItem";

export default function ChartLegend({
  legend,
  lengedType,
  activeOrgs,
  toggleOrg,
}: {
  legend?: LegendType[];
  lengedType: string;
  activeOrgs: string[];
  toggleOrg: (key: string) => void;
}) {
  const { chartId } = useStatsWidget();
  if (!legend) return null;
  if (lengedType === "range") {
    return null;
  }
  if (lengedType === "list") {
    return (
      <s.Chart.LegendList>
        {legend.map((row, index) => (
          <Fragment key={index}>
            <s.Chart.LegendListItem key={index}>
              <s.Chart.LegendItemLabel isListType $color={row.color}>
                {row.label}
              </s.Chart.LegendItemLabel>
              <s.Chart.LegendItemValue isListType>
                {row.value}
              </s.Chart.LegendItemValue>
            </s.Chart.LegendListItem>
          </Fragment>
        ))}
      </s.Chart.LegendList>
    );
  }
  const isActive = (key: string) => (activeOrgs ?? []).includes(key);
  return (
    <s.Chart.Legend>
      {legend.map((c) => (
        <s.Chart.LegendItem key={c.label}>
          <s.Chart.LegendItemLabel $color={c.color}>
            {c.label}
          </s.Chart.LegendItemLabel>
          <s.Chart.LegendItemValue $color={c.color}>
            {c.value}
          </s.Chart.LegendItemValue>
          {c.children?.map((child) => (
            <s.Chart.LegendItem key={child.label}>
              <s.Chart.LegendItemLabel $color={child.color}>
                {child.label}
              </s.Chart.LegendItemLabel>
              <s.Chart.LegendItemValue>{child.value}</s.Chart.LegendItemValue>
            </s.Chart.LegendItem>
          ))}
          {c.key && (
            <s.Chart.SwitchContainer $color={c.color}>
              <ToggleComponent
                isToggled={isActive(c.key)}
                onChange={(checked) => toggleOrg(c.key as string)}
                dataTestId={`dashboard-stats-graph-legend-toggle-button-${chartId}-${c.key}`}
              />
            </s.Chart.SwitchContainer>
          )}
        </s.Chart.LegendItem>
      ))}
    </s.Chart.Legend>
  );
}